<template>
  <div class="crispy-select">
    <label v-if="label">{{ label }}</label>
    <select :value="modelValue" @input="$emit('update:modelValue', $event.target.value)">
      <option :value="undefined">...filter by tag</option>
      <option v-for="option of options" :value="option" :key="option">
        {{ option }}
      </option>
    </select>
    <CrispyButton @click="$emit('update:modelValue', undefined)" variant="ghost">✖</CrispyButton>
  </div>
</template>

<script>
import CrispyButton from "../button/CrispyButton.vue";
export default {
    name: "CrispySelect",
    props: {
        modelValue: {
            type: [String, undefined],
            default: undefined,
            required: false,
        },
        options: {
            type: Array,
            default() {
                return [];
            },
        },
        placeholder: {
            type: String,
            default() {
                return "pick...";
            },
        },
        label: {
            type: String,
        },
    },
    methods: {},
    components: { CrispyButton }
};
</script>

<style scoped lang="scss"></style>
